import { jsxs as _jsxs, Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
import { GenericDropDownV3, TS_MultiSelect_V2 } from '@nu-art/thunderstorm-frontend/index';
import { DBItemDropDownMultiSelector } from '@nu-art/thunderstorm-frontend/components/_TS_MultiSelect/DBItemDropDownMultiSelector';
import { ICONS } from '@app/styles';
import { ModuleFE_EHRInstallation } from './ModuleFE_EHRInstallation.js';
import { ModuleFE_Organization } from '../../../_entity.js';
const Props_DropDown = {
    module: ModuleFE_EHRInstallation,
    modules: [ModuleFE_EHRInstallation],
    mapper: installation => {
        const organization = ModuleFE_Organization.cache.unique(installation.organizationId);
        return [`${organization?.name} > ${installation.label}`];
    },
    placeholder: 'Choose an EHR Installation',
    renderer: installation => _jsxs("div", { className: "ll_h_c", children: [" ", installation.label, " "] })
};
export const DropDown_EHRInstallation = GenericDropDownV3.prepare(Props_DropDown);
const Props_MultiSelect = DBItemDropDownMultiSelector.propsV3({
    module: ModuleFE_EHRInstallation,
    itemRenderer: (item, onDelete) => {
        return !item ? _jsx(_Fragment, { children: "Not Found" }) : _jsxs(_Fragment, { children: [_jsx(ICONS.x.component, { onClick: onDelete, className: 'ts-icon__small' }), item.label] });
    },
    uiSelector: DropDown_EHRInstallation.selectable,
});
export const MultiSelect_EHRInstallation = TS_MultiSelect_V2.prepare(Props_MultiSelect);
//# sourceMappingURL=ui-components.js.map